import { makeVar } from '@apollo/client';

export const isSurveyWasTriggeredOnAppStart = makeVar(false);
